import { Button, Form } from "react-bootstrap";
import FormRow from "./FromRow.component";
import { useForm } from "react-hook-form";

function ChartSettingForm({ onCloseModal }) {
  let chartSetting = localStorage.getItem("chart_settings");

  const { register, formState, handleSubmit } = useForm({
    defaultValues: chartSetting ? JSON.parse(chartSetting) : {},
  });

  const { errors } = formState;

  const onSubmit = data => {
    localStorage.setItem("chart_settings", JSON.stringify(data));
    onCloseModal(false);
    window.location.reload();
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ width: "50vw" }}>
      <h4>CHARTS SETTINGS</h4>
      <hr />
      <div className="d-flex gap-4 ">
        <div className="w-50">
          <FormRow label="Chart Type" error={errors?.chartType?.message}>
            <Form.Select
              id="chartType"
              {...register("chartType", {
                required: "This field is required",
              })}
            >
              <option value="">Choose Chart type</option>
              <option value="0">Bars</option>
              <option value="1">candles</option>
              <option value="9">hollow candles</option>
              <option value="8">Heikin Ashi</option>
              <option value="2">Line</option>
              <option value="3">Area</option>
              <option value="4">Renko</option>
              <option value="7">Line Break</option>
              <option value="5">Kagi</option>
              <option value="6">Point and Figure</option>
            </Form.Select>
          </FormRow>
          <FormRow label="Chart theme" error={errors?.chartTheme?.message}>
            <Form.Select
              id="chartTheme"
              {...register("chartTheme", {
                required: "This field is required",
              })}
            >
              <option value="">Choose Chart theme</option>
              <option value="dark">Dark</option>
              <option value="light">Light</option>
            </Form.Select>
          </FormRow>
          <FormRow label="Time interval" error={errors?.timeInterval?.message}>
            <Form.Select
              id="timeInterval"
              {...register("timeInterval", {
                required: "This field is required",
              })}
            >
              <option value="">Choose time interval</option>
              <option value="D">Daily</option>
              <option value="W">Weekly</option>
            </Form.Select>
          </FormRow>
        </div>
        <div className="w-50">
          <Form.Check id="showDrawingToolsBar" label="Show drawing tools bar" {...register("showDrawingToolsBar")} />
          <Form.Check id="enable_publishing" label="Enable publishing" {...register("enable_publishing")} />
          <Form.Check id="show_volume" label="Show Volume" {...register("show_volume")} />
          <Form.Check id="show_calender" label="Show Calendar" {...register("show_calender")} />

          <Form.Check id="show_top_toolbar" label="Show top toolbar" {...register("show_top_toolbar")} />
          <Form.Check id="show_bottom_toolbar" label="Show bottom toolbar" {...register("show_bottom_toolbar")} />
          <Form.Check id="show_hotlist" label="Show Hotlist" {...register("show_hotlist")} />
          <Form.Check id="show_details" label="Show details" {...register("show_details")} />
        </div>
      </div>

      <div className="d-flex justify-content-end ">
        <Button onClick={onCloseModal} className="trade-btn" variant="outline-secondary">
          CANCEL
        </Button>
        <Button type="submit" className="trade-btn" variant="success">
          SUBMIT
        </Button>
      </div>
    </form>
  );
}

export default ChartSettingForm;
